define('lq/onlongpress',[
    'jquery'
], function ($) {
    'use strict';

    function OnLongPress() {
    };

    OnLongPress.prototype.applyLongPressOnElement = function ($element, drop, eventArg, callback, eventName, $scrollableElement) {
        eventName = eventName || 'onLongPress';

        var scrolledOrMoved = false;
        if ($scrollableElement) {
            $scrollableElement.on('scroll touchmove', function () {
                scrolledOrMoved = true;
                clearTimeout(pressTimer);
            });
        }
        var pressTimer;

        var timeout = drop.data.longPressDelay ? drop.data.longPressDelay : 1000;

        var longPressTriggered = false;

        var longPressEvent = drop.getEventDataFor(eventName);
        var clickedEvent = drop.getEventDataFor('clicked');
        if (longPressEvent && longPressEvent.enabled) {
            $element.on('mouseup touchend', function(e) {
                if (!longPressTriggered && drop.data.eventing && drop.data.eventing.clicked && drop.data.eventing.clicked.enabled === true) {
                    if (callback && !scrolledOrMoved) {
                        callback(e);
                    } else if ((eventArg === null || eventArg === undefined) && !scrolledOrMoved) {
                        drop.triggerEvent(clickedEvent.raisedEventName);
                    } else {
                        if (typeof eventArg === 'function' && !scrolledOrMoved) {
                            var determinedEventArg = eventArg(e);
                            drop.triggerEvent(clickedEvent.raisedEventName, determinedEventArg);
                        } else if (!scrolledOrMoved) {
                            drop.triggerEvent(clickedEvent.raisedEventName, eventArg);
                        }
                    }
                }
                scrolledOrMoved = false;
                clearTimeout(pressTimer);
            }).on('mousedown touchstart', function(e) {
                longPressTriggered = false;
                pressTimer = window.setTimeout(function () {
                    if (eventArg === null || eventArg === undefined) {
                        drop.triggerEvent(longPressEvent.raisedEventName);
                    } else {
                        if (typeof eventArg === 'function') {
                            var determinedEventArg = eventArg(e);
                            drop.triggerEvent(longPressEvent.raisedEventName, determinedEventArg);
                        } else {
                            drop.triggerEvent(longPressEvent.raisedEventName, eventArg);
                        }
                    }
                    longPressTriggered = true;
                }, timeout);
            });
        }
    };

    return new OnLongPress();
});

